<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'

import { useFullscreen } from '@vueuse/core'

const { execute: resetGame, hasHandler: hasResetHandler } = useGameReset()
const colorMode = useColorMode()
const router = useRouter()
const { t } = useI18n()

const { isFullscreen, toggle: toggleFullscreen } = useFullscreen()

const aboutOpen = ref(false)

const items = computed<DropdownMenuItem[][]>(() => [
  [
    {
      icon: colorMode.value === 'dark' ? 'mdi:weather-sunny' : 'mdi:weather-night',
      label: colorMode.value === 'dark' ? t('gameFab.colorMode.light') : t('gameFab.colorMode.dark'),
      onSelect() {
        colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark'
      },
    },
    {
      icon: isFullscreen.value ? 'mdi:fullscreen-exit' : 'mdi:fullscreen',
      label: isFullscreen.value ? t('gameFab.fullscreen.exit') : t('gameFab.fullscreen.enter'),
      onSelect() {
        toggleFullscreen()
      },
    },
  ],
  [
    {
      icon: 'mdi:information-outline',
      label: t('gameFab.about'),
      onSelect() {
        aboutOpen.value = true
      },
    },
  ],
  ...(hasResetHandler.value
    ? [
        [
          {
            color: 'warning' as const,
            icon: 'mdi:restart',
            label: t('gameFab.resetGame'),
            onSelect() {
              resetGame()
            },
          },
        ],
      ]
    : []),
  [
    {
      color: 'error' as const,
      icon: 'mdi:home-outline',
      label: t('gameFab.exitHome'),
      onSelect() {
        router.push('/')
      },
    },
  ],
])
</script>

<template>
  <div class="fixed bottom-4 left-4 z-50">
    <UDropdownMenu
      :items="items"
      :content="{ side: 'top', align: 'start', sideOffset: 8 }"
      :modal="false"
      :ui="{ content: 'w-44' }"
    >
      <UButton
        color="neutral"
        variant="soft"
        icon="mdi:cog-outline"
        size="sm"
        class="opacity-30 hover:opacity-80 focus-visible:opacity-80 transition-opacity"
        aria-label="Game options"
      />
    </UDropdownMenu>

    <AboutModal
      v-model:open="aboutOpen"
      @close="aboutOpen = false"
    />
  </div>
</template>
